import { useMemo } from 'react'

import {
  CompositeTableTemplate,
  renderCellGrayZerosRedConditions,
} from 'app/common/templates-next/table-template'

import {
  ColumnKey,
  columnKeysLeft,
  columnKeysMain,
  headerCellsProps,
  cellsProps,
  getHeaderCells,
} from './tableColumns'

import { ItemByDatesType } from 'app/dataTypes/reports/data/common/financesSummary'
import { useCurrencySign } from 'app/common/components-next/currency'

type Props = {
  data: Array<ItemByDatesType>
  pending: boolean
}

export const TableGroupByDates = ({ data, pending }: Props) => {
  const currency = useCurrencySign()
  const tableData = useMemo(() => {
    return {
      columnKeysLeft,
      columnKeysMain,
      header: getHeaderCells(currency),
      headerProps: headerCellsProps,
      data: data.map(
        ({
          date,
          balanceBefore,
          balanceAfter,
          writeOffs,
          paymentsResult,
          correctionPaymentsResult,
          check,
        }) => ({
          rowKey: date.getString('DD.MM.YY'),
          rowData: {
            [ColumnKey.Date]: {
              columnKey: ColumnKey.Date as const,
              value: date.getString('DD.MM.YY'),
            },
            [ColumnKey.BalanceBefore]: {
              columnKey: ColumnKey.BalanceBefore as const,
              value: balanceBefore,
              isRedNegative: true,
            },
            [ColumnKey.WriteOffs]: {
              columnKey: ColumnKey.WriteOffs as const,
              value: writeOffs,
            },
            [ColumnKey.PaymentsResult]: {
              columnKey: ColumnKey.PaymentsResult as const,
              value: paymentsResult,
            },
            [ColumnKey.CorrectionPaymentsResult]: {
              columnKey: ColumnKey.CorrectionPaymentsResult as const,
              value: correctionPaymentsResult,
            },
            [ColumnKey.BalanceAfter]: {
              columnKey: ColumnKey.BalanceAfter as const,
              value: balanceAfter,
              isRedNegative: true,
            },
            [ColumnKey.Check]: {
              columnKey: ColumnKey.Check as const,
              value: check,
              isRedNegative: true,
              isRedPositive: true,
            },
          },
        }),
      ),
      dataProps: cellsProps,
    }
  }, [data, currency])

  return (
    <CompositeTableTemplate
      data={tableData}
      loading={pending}
      renderCell={renderCellGrayZerosRedConditions}
      borderTop
    />
  )
}
